// extracted by mini-css-extract-plugin
export default {"container":"FormGroup_container__B0WLN","title":"FormGroup_title__-985m","content":"FormGroup_content__EFSbu","contentDisabled":"FormGroup_contentDisabled__jjgtp"};